import type { Competition } from "~types/competition";
import type { LabelValue } from "~types/labelValue";

const getCompetitionOptions = (competitions: { [id: string]: Competition }): LabelValue[] =>
  Object.values(competitions).map(({ nameLocal, competitionId }) => ({ value: competitionId, label: nameLocal }));

export default getCompetitionOptions;
